module.exports = __webpack_public_path__ + "static/media/YM43_0.e7366661.jpg";